export class CConfig {
	public static readonly gameWD:number = 1136;
	public static readonly gameHT:number = 640;
    public static readonly gameTarget:string = "H5";
	// public static readonly gameTarget:string = "iOS";
	// public static readonly gameTarget:string = "Android";
	public static readonly showWifiStatus:boolean = false;
	public static readonly usedAppACK:boolean = true;
	public static readonly testDBID:number = 250200001;

	public static readonly reconLocalTest:boolean = false;
    public static readonly gameVersion:number = 100106;
	public static readonly usedLine:boolean = true;
	
	public static readonly webURL:string = "https://wuji.hugashaga.com.tw";
	public static readonly gameURL:string = "https://liff.line.me/2001560893-ZOq2LjdG";

	// public static readonly baseURL:string = "http://192.168.1.200/";
    // public static readonly gameServer:string = "ws://192.168.1.200:15500";
	
	public static readonly baseURL:string = "https://wuji.hugashaga.com.tw/";
	public static readonly gameServer:string = "wss://wuji.hugashaga.com.tw:17500";

	public static readonly urlBulletin:string = "https://wuji.hugashaga.com.tw/api/Placard/Wuji_Placard";
	public static readonly urlRecords:string = "https://wuji.hugashaga.com.tw/api/GameLog/Wuji_Replay";
	public static readonly urlRanking:string = "https://wuji.hugashaga.com.tw/api/GameLog/Wuji_RankQuery";
}

// class AppConfig {
// 	static readonly BASE_URL = AppConfig.isDevelopment() 
// 		? "https://dev-api.example.com" 
// 		: "https://api.example.com";

// 	private static isDevelopment(): boolean {
// 		// 這裡的判斷方式取決於你的開發環境 (Vite 使用 import.meta.env.DEV)
// 		return process.env.NODE_ENV === "development";
// 	}
// }
